export const enMyspecialtyFieldOptions = [
  {
    value: "pharmacist",
    label: "Pharmacist",
  },
  {
    value: "physician",
    label: "Physician",
  },
  {
    value: "nurse",
    label: "Nurse",
  },
];

export const frMyspecialtyFieldOptions = [
  {
    value: "pharmacist",
    label: "Pharmacien",
  },
  {
    value: "physician",
    label: "Médecin",
  },
  {
    value: "nurse",
    label: "Infirmier",
  },
];

export const enRegionFieldOptions = [
  {
    value: "ALBERTA",
    label: "ALBERTA",
  },
  {
    value: "BRITISH COLUMBIA",
    label: "BRITISH COLUMBIA",
  },
  {
    value: "MANITOBA",
    label: "MANITOBA",
  },
  {
    value: "NEW BRUNSWICK",
    label: "NEW BRUNSWICK",
  },
  {
    value: "NEWFOUNDLAND & LABRADOR",
    label: "NEWFOUNDLAND & LABRADOR",
  },
  {
    value: "NORTHWEST TERRITORIES",
    label: "NORTHWEST TERRITORIES",
  },
  {
    value: "NOVA SCOTIA",
    label: "NOVA SCOTIA",
  },
  {
    value: "NUNAVUT",
    label: "NUNAVUT",
  },
  {
    value: "ONTARIO",
    label: "ONTARIO",
  },
  {
    value: "PRINCE EDWARD ISLAND",
    label: "PRINCE EDWARD ISLAND",
  },
  {
    value: "QUEBEC",
    label: "QUEBEC",
  },
  {
    value: "SASKATCHEWAN",
    label: "SASKATCHEWAN",
  },
  {
    value: "YUKON",
    label: "YUKON",
  },
];

export const frRegionFieldOptions = [
  {
    value: "ALBERTA",
    label: "ALBERTA",
  },
  {
    value: "BRITISH COLUMBIA",
    label: "COLOMBIE-BRITANNIQUE",
  },
  {
    value: "MANITOBA",
    label: "MANITOBA",
  },
  {
    value: "NEW BRUNSWICK",
    label: "NOUVEAU-BRUNSWICK",
  },
  {
    value: "NEWFOUNDLAND & LABRADOR",
    label: "TERRE-NEUVE-ET-LABRADOR",
  },
  {
    value: "NORTHWEST TERRITORIES",
    label: "TERRITORIES DU NORD-OUEST",
  },
  {
    value: "NOVA SCOTIA",
    label: "NOUVELLE-ÉCOSSE",
  },
  {
    value: "NUNAVUT",
    label: "NUNAVUT",
  },
  {
    value: "ONTARIO",
    label: "ONTARIO",
  },
  {
    value: "PRINCE EDWARD ISLAND",
    label: "ÎLE-DU-PRINCE-ÉDOUARD",
  },
  {
    value: "QUEBEC",
    label: "QUÉBEC",
  },
  {
    value: "SASKATCHEWAN",
    label: "SASKATCHEWAN",
  },
  {
    value: "YUKON",
    label: "YUKON",
  },
];



// WEBPACK FOOTER //
// ./src/mi-app/modals/WelcomeMI_fieldOptions.js